<template>
  <div ref="partnersLinkCard" class="partner-link-card">
    <h2>Partner ID</h2>
    <p>Your Partner ID</p>

    <h1>
      {{ partnerID }}
    </h1>

    <div
      v-clipboard:copy="partnerID"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <ButtonFilled
        @onButtonClicked="() => {}"
        text="Copy Partner ID"
      ></ButtonFilled>
      <div style="height: 8px"></div>
    </div>
  </div>
</template>

<script>
import ButtonFilled from "../../common/ButtonFilled";
export default {
  components: {
    ButtonFilled,
  },
  computed: {
    partnerID() {
      return this.$store.getters["userStore/getPartnerDetails"].partner.partnerID;
    },
  },
  async mounted() {
    await this.sleep(20);
    console.log(this.$store.getters["userStore/getPartnerDetails"].partner.partnerID)
    this.$refs.partnersLinkCard.style = "transform: scale(1) !important";
  },
  methods: {
    onCopy: function() {
      alert("Partner ID copied to clipboard");
    },
    onError: function() {
      alert("Failed to copy texts");
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.partner-link-card {
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
  max-height: 275px;
  max-width: 30%;
  height: 265px;
  width: 30%;
  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;

}

.partner-link-card > h2 {
  font-size: 22px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #e0e0e0;
  margin-top: 15px;
}

.partner-link-card > p {
  font-size: 12px !important;
  font-family: "OpenSans";
  text-align: center;
  color: #888888;
  margin-top: 5px;
}

.partner-link-card > h1 {
  font-size: 16px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #ffffff;
  margin-top: 31px;
  margin-bottom: 42px;
  word-break: break-all;
}
.captcha-card-with-button-container > h1 > span {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans";
}
</style>
